import { render, staticRenderFns } from "./ApprovalNodeConfig.vue?vue&type=template&id=513730b5&scoped=true"
import script from "./ApprovalNodeConfig.vue?vue&type=script&lang=js"
export * from "./ApprovalNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./ApprovalNodeConfig.vue?vue&type=style&index=0&id=513730b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513730b5",
  null
  
)

export default component.exports